import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import AWS from 'aws-sdk'
import Amplify, {Auth, Storage} from 'aws-amplify';
import awsconfig from './aws-exports';

Amplify.configure(awsconfig);
// custom config to allow for existing s3 bucket
// https://docs.amplify.aws/lib/storage/getting-started/q/platform/js#configure-your-application
Amplify.configure({
	Auth: {
        identityPoolId: Auth._config.identityPoolId, //REQUIRED - Amazon Cognito Identity Pool ID
        region: Auth._config.aws_cognito_region, // REQUIRED - Amazon Cognito Region
        userPoolId: Auth._config.aws_user_pools_id, //OPTIONAL - Amazon Cognito User Pool ID
        userPoolWebClientId: Auth._config.aws_user_pools_web_client_id, //OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
        AWSS3: {
            bucket: 'sternberg-sequencing-data', //REQUIRED -  Amazon S3 bucket name
            region: 'us-east-1', //OPTIONAL -  Amazon service region
        }
    }
})
AWS.config.update({region: 'us-east-1'})

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
